export default __webpack_public_path__ + "static/media/S (19).e8314a24.png";